import React from 'react';
import { Field } from 'redux-form';

import { INFO_WINDOW_POSITION } from 'components/InfoWindowSettings/InfoWindowConstants';
import { ButtonGroup, ButtonGroupItem } from 'components/Shared/Forms';
import { GLYPHS } from 'components/Shared/Icon';

const InfoWindowPosition = ({ input }) => (
    <ButtonGroup>
        {Object.entries(INFO_WINDOW_POSITION).map(([key, obj]) => {
            return (
                <ButtonGroupItem
                    title={obj.label}
                    titlePlacement="top"
                    type="button"
                    key={key}
                    glyph={GLYPHS[`INFO_WINDOW_${key}`]}
                    selected={input.value === key}
                    onClick={() => input.onChange(key)}
                />
            );
        })}
    </ButtonGroup>
);

const InfoWindowPositionField = (props) => <Field component={InfoWindowPosition} {...props} />;
export default InfoWindowPositionField;
